<template>
	<div>
		<v-flex xs12 text-xs-left mb-2>
			<label class="label-title">Completa los datos</label>
		</v-flex>
		<v-layout row wrap>
			<v-flex xs2 mr-3 text-xs-left>
				<input-text
					label-text="Nombre"
					v-model="seller.name"
				/>
				<span class="caption red--text"
					v-if="!$v.seller.name.required">
					El nombre es requerido.
				</span>
			</v-flex>
			<v-flex xs2 mr-3 text-xs-left>
				<input-text
					label-text="Apellidos"
					v-model="seller.lastName"
				/>
			</v-flex>
			<v-flex xs4 mr-3 text-xs-left>
				<type-document-input
					labelText="Identificación del empleado"
					placeholder="Identificación"
					:search="true"
					v-model="seller.entity"
				/>
				<span class="caption red--text"
					v-if="$v.customer.entity.documentType && $v.customer.entity.documentType.$invalid">
					El tipo de indentificación es requerida.
				</span>
				<span class="caption red--text"
					v-if="!$v.seller.entity.numDocument.required">
					La indentificación es requerida.
				</span>
			</v-flex>
			<v-flex xs2 mr-3 text-xs-left>
				<select-date
					icon="event"
					label-text="Fecha de nacimiento"
					v-model="seller.dateBirth"
				/>
			</v-flex>
			<v-flex xs2 mr-3 text-xs-left>
				<input-text
					type="email"
					label-text="Correo electrónico"
					v-model="seller.email"
				/>
				<span class="caption red--text"
					v-if="!$v.seller.email.required">
					El correo es requerido
				</span>
				<span class="caption red--text"
					v-if="!$v.seller.email.email">
					correo inválido
				</span>
			</v-flex>
			<v-flex xs2 mr-3 text-xs-left>
				<input-text
					type="tel"
					label-text="Teléfono"
					v-model="seller.phone"
				/>
				<span class="caption red--text"
					v-if="!$v.seller.phone.minLength">
					mínimo 6 dígitos
				</span>
				<span class="caption red--text"
					v-if="!$v.seller.phone.maxLength">
					máximo 11 dígitos
				</span>
			</v-flex>
			<v-flex xs2 text-xs-left mb-2 mr-3>
				<select-button
					autocomplete
					label
					labelText="País"
					itemText="name"
					itemValue="id"
					placeholder="País"
					:items="countries"
					v-model="seller.country"
				/>
			</v-flex>
			<v-flex xs2 text-xs-left mb-2 mr-3>
				<select-button
					label
					labelText="Género"
					itemText="name"
					itemValue="id"
					placeholder="Género"
					:items="genders"
					v-model="seller.gender"
				/>
			</v-flex>
			<v-flex xs2 text-xs-left mb-2 mr-3>
				<select-button
					label
					labelText="Estado Civil"
					itemText="name"
					itemValue="id"
					placeholder="Estado Civil"
					:items="civilStatus"
					v-model="seller.civilStatus"
				/>
			</v-flex>
			<v-flex xs2 mr-3 text-xs-left>
				<select-date
					icon="event"
					label-text="Fecha de ingreso"
					v-model="seller.dateHealing"
				/>
			</v-flex>
			<v-flex xs2 mr-3 text-xs-left>
				<input-text
					readonly
					label-text="Venta Total"
					v-model.number="seller.totalSales"
				/>
			</v-flex>
		</v-layout>
		<v-layout row mt-3>
			<v-flex xs2 d-flex justify-start>
				<v-btn
					class="btn-action btn-save white--text"
					@click="saveEmployee"
					:disabled="$v.$invalid"
				>
					Guardar
				</v-btn>
			</v-flex>
		</v-layout>
	</div>
</template>
<script>
import { required, email, minLength, maxLength } from 'vuelidate/lib/validators';
import inputText from '@/clerkinn/shared/input-text';
import selectDate from '@/clerkinn/shared/select-date';
import selectButton from '@/clerkinn/shared/select-button';
import typeDocumentInput from '@/clerkinn/shared/type-document-input';
import lib from '@/shared/lib';
import mixins from '@/shared/mixins';

const { compose, setNewProperty } = lib;

function mounted() {
	this.loadData();
	this.sellerId = this.$route.params.sellerId;
	if (this.sellerId) {
		this.loadEmployeeData(this.sellerId);
	}
}

async function loadEmployeeData(id) {
	const url = `${process.env.PMS_URL}/employees/${id}`;
	const { data: response } = await this.$http.get(url);
	this.seller = this.showEmployeeData(response);
}

function showEmployeeData(info) {
	const { data: seller } = info;
	return compose(
		setNewProperty('name', seller.name),
		setNewProperty('lastName', seller.lastname),
		setNewProperty('entity', { numDocument: seller.dni, documentType: seller.documentType }),
		setNewProperty('dateBirth', seller.dateBirth),
		setNewProperty('email', seller.email),
		setNewProperty('phone', seller.phone),
		setNewProperty('country', seller.countryId),
		setNewProperty('gender', seller.gender),
		setNewProperty('civilStatus', seller.civilStatus),
		setNewProperty('dateHealing', seller.dateHealing),
		setNewProperty('totalSales', seller.salesAmount),
	)(this.seller);
}

async function loadData() {
	const requests = [
		this.$http.get(`${process.env.PMS_URL}/hotel`),
		this.$http.get(`${process.env.PMS_URL}/countries`),
	];
	const [
		{ data: subsidiaries },
		{ data: countries },
	] = await Promise.all(requests);
	this.subsidiaries = subsidiaries.data;
	this.countries = countries.data;
}

async function saveEmployee() {
	const urlPost = `${process.env.PMS_URL}/sellers`;
	const urlPut = `${process.env.PMS_URL}/sellers/${this.sellerId}`;
	const url = this.sellerId ? urlPut : urlPost;
	const messagePost = 'creado';
	const messagePut = 'actualizado';
	const message = this.sellerId ? messagePut : messagePost;
	const body = this.buildBody(this.seller);
	const method = this.sellerId ? 'put' : 'post';
	await this.$http[method](url, body);
	this.showNotification(`Empleado ${message} exitosamente`, 'success');
	this.$router.push({ name: 'sellers-list' });
}

function buildBody(seller) {
	return compose(
		setNewProperty('name', seller.name),
		setNewProperty('lastname', seller.lastName),
		setNewProperty('documentType', seller.entity.documentType),
		setNewProperty('numDocument', seller.entity.numDocument),
		setNewProperty('email', seller.email),
		setNewProperty('phone', seller.phone),
		setNewProperty('civilStatus', seller.civilStatus),
		setNewProperty('dateBirth', seller.dateBirth),
		setNewProperty('dateHealing', seller.dateHealing),
		setNewProperty('gender', seller.gender),
		setNewProperty('countryId', seller.countryId),
	)({});
}

function validations() {
	return {
		seller: {
			name: { required },
			entity: {
				numDocument: { required },
				documentType: { required },
			},
			email: { required, email },
			phone: {
				minLength: minLength(6),
				maxLength: maxLength(11),
			},
		},
	};
}

function data() {
	return {
		civilStatus: [
			{ id: 1, name: 'Soltero(a)' },
			{ id: 2, name: 'Casado(a)' },
			{ id: 3, name: 'Viudo(a)' },
			{ id: 4, name: 'Divorciado(a)' },
		],
		countries: [],
		seller: {
			dateBirth: '',
			civilStatus: null,
			country: null,
			dateHealing: '',
			entity: {
				numDocument: null,
				documentType: null,
			},
			email: '',
			gender: null,
			lastName: '',
			name: '',
			phone: '',
			totalSales: '',
		},
		sellerId: null,
		genders: [
			{ id: 1, name: 'Hombre' },
			{ id: 2, name: 'Mujer' },
		],
		subsidiaries: [],
	};
}

export default {
	name: 'new-seller',
	components: {
		inputText,
		selectButton,
		selectDate,
		typeDocumentInput,
	},
	data,
	methods: {
		buildBody,
		loadData,
		loadEmployeeData,
		saveEmployee,
		showEmployeeData,
	},
	mixins,
	mounted,
	validations,
};
</script>

<style lang="scss" scoped>
.label-title {
	color: map-get($colors, dark);
	font-family: map-get($fonts, medium);
	font-size: map-get($sizes, fourteen);
}

.container-height {
	height: fit-content;
}
</style>



// WEBPACK FOOTER //
// New.vue?5aa910a2